import React, { useState, useRef, useEffect } from "react";
import { IGlossaryContentBlockModel } from "../models/glossary-page-models";

interface IProps {
    glossaryContentItem: IGlossaryContentBlockModel;
}

const GlossaryContentItem = (props: IProps) => {
    useEffect(() => {
        window.Tooltips();
    }, []);
    return (
        <div className="glossary-results-item" id={`item-${props.glossaryContentItem.id}`}>
            <div className="glossary-results-item-header" >
                {props.glossaryContentItem.iconImageUrl &&
                    <img src={props.glossaryContentItem.iconImageUrl} alt={props.glossaryContentItem.heading} />}
                <h3 data-anchor-link-title={props.glossaryContentItem.heading}>{props.glossaryContentItem.heading}</h3>
            </div>
            <div dangerouslySetInnerHTML={{ __html: props.glossaryContentItem.description }} />
        </div>
    )
}

export default GlossaryContentItem